import Base from "./base"
import {Participant} from "socket_if"

export default class MoveParticipant extends Base {
  constructor(Vue, store) {
    super("move-participant", Vue, store)
  }

  async after(to, from) {
    console.log("move-participant")

    const toRouteName = to.name
    const hall = this.store.getters["hall/getBySlug"](to.params.hallSlug || from.params.hallSlug)
    const room = this.store.getters["room/getBySlug"](to.params.roomSlug || from.params.roomSlug)
    const talkRoom = to.params.roomName || from.params.roomName
    const user = this.store.getters["auth/user"]

    // socketのinit処理が実行されている場合のみ移動処理を実行する
    if (this.vm.prototype.$socket.inited) {
      if (_.isEmpty(hall)) {
        user.hall = null
      } else {
        user.hall = hall.slug
      }

      if (["Top", "Hall"].some(route => route === toRouteName)) {
        user.room = null
      } else if (toRouteName === "TalkRoom") {
        user.room = talkRoom
      } else if (["YRoomEntry", "TalkRoomEntry"].some(route => route === toRouteName)) {
        user.room = toRouteName === "TalkRoomEntry" && talkRoom ? `${talkRoom}_entry` : `${room.slug}_entry`
      } else {
        user.room = _.isEmpty(room) ? "hall_room" : room.slug
      }

      if (["Notice", "Setting"].some(route => route === toRouteName) || !hall) {
        user.room = null
      }

      user.avatar = user.icon_url
      user.updatedAt = this.vm.prototype.$moment.now()

      this.vm.prototype.$socket.dispatcher.moveParticipant(new Participant(user))
    }
  }
}
